import { useEffect, useRef, useState } from "react";
import { SlideToMoveIcon } from "frontend/icons/slide-to-move";
import SuccessAnimation from "frontend/canvas-onboarding/cim-onboarding/phases/device-selection/success-animation/success-animation";
import styles from "./navigation-step.module.css";
import { useAtomValue } from "jotai";
import { posScaleAtom } from "state-atoms";
import tracking from "frontend/tracking";

interface TrackpadSlideStepProps {
  name: string;
  completeStep: () => void;
}

export default function TrackpadSlideStep({ name, completeStep }: TrackpadSlideStepProps) {
  const posScale = useAtomValue(posScaleAtom);
  const [showSuccess, setShowSuccess] = useState(false);
  const previousPosScale = useRef({
    x: posScale.x,
    y: posScale.y,
    scale: posScale.scale,
  });
  const hasCompletedRef = useRef(false);

  useEffect(() => {
    const positionChanged = posScale.x !== previousPosScale.current.x || posScale.y !== previousPosScale.current.y;
    const scaleUnchanged = posScale.scale === previousPosScale.current.scale;

    if (!hasCompletedRef.current && positionChanged && scaleUnchanged) {
      hasCompletedRef.current = true;
      setShowSuccess(true);
      tracking.trackAnalyticsEvent(`${name}_success`);
    }

    previousPosScale.current = {
      x: posScale.x,
      y: posScale.y,
      scale: posScale.scale,
    };
  }, [posScale, name]);

  return (
    <SuccessAnimation showSuccess={showSuccess} successImage="yeah" onComplete={completeStep}>
      <div className={styles.trackpadStepsContainer}>
        <SlideToMoveIcon />
      </div>
    </SuccessAnimation>
  );
}
